class PDFPreviewService {
  setter = null;

  register(fn) {
    this.setter = fn;
  }

  show(payload) {
    if (!this.setter) {
      console.error('❌ PreviewService NOT registered');
      return;
    }

    this.setter({
      visible: true,
      ...payload
    });
  }

}

export default new PDFPreviewService();
